import * as emoji from 'node-emoji'
import { SearchItem } from 'hooks/useArrowsNavigation'

export const searchEmoji = (keyWord: string): SearchItem[] =>
  emoji
    .search(keyWord)
    .map((item) => ({ emoji: item.emoji, name: `${item.name}:` }))
